import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-purpose',
  templateUrl: './purpose.component.html',
  styleUrls: ['./purpose.component.scss']
})
export class PurposeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  onpurposeFormSubmit(purposeForm){

    //console.log(purposeForm.value);
  }
}
